import { gql } from '@apollo/client';
import { ME_FRAGMENT } from 'graphql/fragments';

/* eslint-disable import/prefer-default-export */

export const ME = gql`
  query Me {
    me {
      ...MeParts
    }
  }
  ${ME_FRAGMENT}
`;
